export default __webpack_public_path__ + "static/media/modern-landing.2c26cfac.jpg";